import React from "react";
import { useParams, useHistory } from "react-router-dom";
import DocumentPreview from "../components/DocumentPreview";
import { Paper, Button } from "@material-ui/core";
import { Api } from "../api";

export default function DocumentViewPage() {
  const { documentId } = useParams();
  const history = useHistory();
  //const [url, setUrl] = React.useState("");

  //function handleUrlLoaded(documentUrl: string) {
  //  setUrl(documentUrl)
  //}

  function downloadDocument(documentId: string) {
    Api.documents.download(documentId);
  }

  return (
    <>
      {documentId ? (
        <div style={{ height: "calc(100vh - 146px)" }}>
          <DocumentPreview documentId={documentId} />
          <Paper
            className="buttons-container right"
            elevation={4}
            style={{
              background: "#f5f5f5",
              padding: "16px 40px",
              borderRadius: 0,
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0
            }}
          >
            <div style={{ flex: 1 }} />
              <Button
                style={{ margin: 0, marginRight: 25, marginTop: 6 }}
                onClick={() => downloadDocument(documentId)}
              >
                Download & Print
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => history.goBack()}
              style={{ margin: 0 }}
            >
              Done
            </Button>
          </Paper>
        </div>
      ) : null}
    </>
  );
}
